import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Edit } from 'jbc-front/components/icons';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { SubHeadding, SubItem, SubPanel } from '@/components/SubPanel';
import { Grid } from '@/components/ui/Grid';
import { Dd, Dl, Dt } from '@/components/ui/DefinitionList';
import { displayFormat, optionalBooleanFormat } from '@/components/utils/formatter';
import { RegularHealthCheckupResult } from '../../../query';
import { ViewProps } from './ViewProps';

export const Hearing: FC<ViewProps> = ({ result, editLink }) => {
  return (
    <Panel>
      <Link to={`${editLink}#hearing`}>
        <Headding icon={<Edit icon={16} />}>聴力</Headding>
      </Link>
      <Item>
        <FrequencyCategory frequency="1000hz" result={result} editLink={editLink} />
        <FrequencyCategory className="u-mt20" frequency="4000hz" result={result} editLink={editLink} />
        <FrequencyCategory className="u-mt20" frequency="other" result={result} editLink={editLink} />
      </Item>
    </Panel>
  );
};

interface FrequencyCategoryProps {
  className?: string;
  frequency: '1000hz' | '4000hz' | 'other';
  result: RegularHealthCheckupResult;
  editLink: string;
}

const categoryHeaders = {
  '1000hz': '1,000Hz',
  '4000hz': '4,000Hz',
  other: 'その他の方法'
};

const FrequencyCategory: FC<FrequencyCategoryProps> = ({ className, frequency, result, editLink }) => {
  const categoryItem = result.regularHealthCheckupResultItems.find(item => item.itemCode === `hearing_${frequency}`);
  const leftItem = result.regularHealthCheckupResultItems.find(item => item.itemCode === `hearing_${frequency}_left`);
  const rightItem = result.regularHealthCheckupResultItems.find(item => item.itemCode === `hearing_${frequency}_right`);
  return (
    <SubPanel className={className}>
      <Link to={`${editLink}#hearing_${frequency}`}>
        <SubHeadding icon={<Edit icon={16} />}>{categoryHeaders[frequency]}</SubHeadding>
      </Link>
      <SubItem>
        <Grid>
          <Dl>
            <Dt>実施有無</Dt>
            <Dd>{optionalBooleanFormat(categoryItem?.checked ?? false, '有', '無')}</Dd>
          </Dl>
          <Dl>
            <Dt>所見有無</Dt>
            <Dd>{optionalBooleanFormat(categoryItem?.hasFinding ?? false, '有', '無')}</Dd>
          </Dl>
        </Grid>
        <Grid className="u-mt20" colGap>
          <SubPanel>
            <Link to={`${editLink}#hearing_${frequency}_left`}>
              <SubHeadding icon={<Edit icon={16} />}>左耳</SubHeadding>
            </Link>
            <Grid sub>
              <Dl>
                <Dt>結果</Dt>
                <Dd>{displayFormat(leftItem?.value)}</Dd>
              </Dl>
              <Dl>
                <Dt>評価</Dt>
                <Dd>{displayFormat(leftItem?.evaluation)}</Dd>
              </Dl>
            </Grid>
          </SubPanel>
          <SubPanel>
            <Link to={`${editLink}#hearing_${frequency}_right`}>
              <SubHeadding icon={<Edit icon={16} />}>右耳</SubHeadding>
            </Link>
            <Grid sub>
              <Dl>
                <Dt>結果</Dt>
                <Dd>{displayFormat(rightItem?.value)}</Dd>
              </Dl>
              <Dl>
                <Dt>評価</Dt>
                <Dd>{displayFormat(rightItem?.evaluation)}</Dd>
              </Dl>
            </Grid>
          </SubPanel>
        </Grid>
      </SubItem>
    </SubPanel>
  );
};
